module.exports = __webpack_public_path__ + "img/tu05.1f45beff.jpg";